import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import styles from "../../../../styles/global-styles";
import CardCategorySelect from "../../../shared/selects/CardCategorySelect";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  box: {
    marginTop: "20px",
  },
  backgroundIcon: styles.backgroundIcon,
  formControl: styles.globalFormControl,
  label: styles.label,
}));

const CashCard = ({ cardOptionSelected }) => {
  const classes = useStyles();

  const [optionCatalogue, setOptionCatalogue] = useState({});

  const handleCardCatalogueSelect = (name, value) => {
    setOptionCatalogue({ ...optionCatalogue, [name]: value });
  };

  return (
    <React.Fragment>
      <Grid container direction="column" alignItems="flex-start">
        <Grid item>
          <Typography variant="h6">
            <Box mt={6} style={{ fontWeight: "bold", color: "#1C2668" }}>
              Seleccionar el proveedor
            </Box>
          </Typography>
        </Grid>
        <Grid item>
          <CardCategorySelect cardCategory={handleCardCatalogueSelect} />
        </Grid>
        {Object.values(optionCatalogue).length > 0 && (
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                cardOptionSelected(optionCatalogue, "cashCard");
              }}
              type="submit"
              style={{ marginTop: "40px", fontSize: 14, width: 150 }}
              endIcon={
                <ArrowRightAltIcon
                  className={classes.backgroundIcon}
                  color="primary"
                ></ArrowRightAltIcon>
              }
            >
              Inventario
            </Button>
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default CashCard;
